module.exports = __webpack_public_path__ + "media/images/dummy-ford-66c813047bd6dae2764e0c967a8fd789.png";